import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { store } from "~/Context/JukeboxContext";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faSadTear } from "@fortawesome/free-solid-svg-icons";

import styled from "styled-components";

export const Wrapper = styled.section`
  font-size: 16px;
  margin: 4px 0 20px 0;
  div {
    background-color: #efefef;
    /* border: 1px solid #b7b3b3; */
    border-radius: 6px;
    overflow: auto;
    padding: 3px 5px;
    line-height: 36px;
    max-width: 220px;
    margin: 0 auto;
  }
  button {
    border: 0;
    padding: 7px;
    margin-right: 8px;
    background-color: transparent;
  }
  .play-icon {
    float: left;
    margin-top: 2px;
    margin-right: 7px;
  }
  &:hover {
    cursor: pointer;
  }
`;

const JukeboxPlayPlaylistCustom = (props) => {
  const { playlistId, playlistName = "Custom Playlist" } = props;
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const [error, setError] = useState(false);

  const playTrack = async () => {
    window.gtag("event", `totd_click`, {
      eventLabel: `Playlist Play: ${playlistName}`,
      playlist_play: `${playlistName}`,
    });
    // await axios.get(`http://localhost:3001/playlist-custom?id=${playlistId}`).then(({ data }) => {
    await axios.get(`//www.dreamchimney.com/api/playlist-custom?id=${playlistId}`).then(({ data }) => {
      // @TODO fix type ?

      const playlist = (data && data[0]) || [];

      if (playlist && playlist.tracks.length) {
        dispatch({ type: "play_playlist", playlist: playlist });
        setError(false);
      } else {
        setError(true);
      }
    });
  };

  if (!playlistId) return null;

  return (
    <span>
      <Wrapper>
        <div onClick={playTrack}>
          <button>
            <FontAwesomeIcon className="play-icon" icon={faPlay} />
          </button>
          Play this Playlist
        </div>
        {error && (
          <div>
            <FontAwesomeIcon className="play-icon" icon={faSadTear} />
            None of the tracks have playable media
          </div>
        )}
      </Wrapper>
    </span>
  );
};

JukeboxPlayPlaylistCustom.propTypes = {
  playlistId: PropTypes.number,
};

export default JukeboxPlayPlaylistCustom;
